import { BaseInput } from './base-input';

export class TextboxEmailInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
